module.exports = __webpack_public_path__ + "img/hsr.beb3826b.svg";